import { z } from "zod";

const password = z
  .string()
  .min(10, "Usa al menos 10 caracteres")
  .regex(/[A-Z]/, "Incluye una mayúscula")
  .regex(/[a-z]/, "Incluye una minúscula")
  .regex(/[0-9]/, "Incluye un número");

export const registerSchema = z
  .object({
    firstName: z.string().trim().min(2).max(80),
    lastName: z.string().trim().min(2).max(80),
    email: z.email().transform((value) => value.toLowerCase()),
    password,
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    path: ["confirmPassword"],
    message: "Las contraseñas no coinciden",
  });

export const loginSchema = z.object({
  email: z.email().transform((value) => value.toLowerCase()),
  password: z.string().min(1),
  remember: z.boolean().optional().default(false),
});

export const productSchema = z.object({
  name: z.string().trim().min(3).max(160),
  slug: z.string().trim().regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
  shortDescription: z.string().trim().min(10).max(240),
  description: z.string().trim().min(20).max(3000),
  categoryId: z.coerce.number().int().positive(),
  price: z.coerce.number().positive().max(99999),
  compareAtPrice: z.coerce.number().positive().max(99999).optional(),
  sizes: z.array(z.string().trim().min(1).max(10)).min(1),
  colors: z.array(z.string().trim().min(2).max(40)).min(1),
  material: z.string().trim().min(3).max(200),
  care: z.string().trim().min(3).max(300),
  image: z.string().trim().max(500).optional().default(""),
  stock: z.coerce.number().int().min(0).max(99999),
  status: z.enum(["DRAFT", "ACTIVE", "OUT_OF_STOCK", "ARCHIVED"]),
  featured: z.boolean().default(false),
  privacyProtected: z.boolean().default(true),
});

export const inquirySchema = z.object({
  productId: z.coerce.number().int().positive(),
  customerName: z.string().trim().min(2).max(120),
  phone: z.string().trim().regex(/^\+?[0-9 ]{7,16}$/),
  email: z.union([z.email(), z.literal("")]).optional(),
  size: z.string().trim().max(10).optional(),
  color: z.string().trim().max(40).optional(),
  quantity: z.coerce.number().int().min(1).max(20),
  message: z.string().trim().max(500).optional(),
});

export const paginationSchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(24),
  search: z.string().trim().max(120).optional().default(""),
});

export type RegisterInput = z.infer<typeof registerSchema>;
export type LoginInput = z.infer<typeof loginSchema>;
export type ProductInput = z.infer<typeof productSchema>;
export type InquiryInput = z.infer<typeof inquirySchema>;
